export const learningThumbnail = url => url? url:process.env.PUBLIC_URL + "/backgrounds/revisionTask/nature.png";

export const fixThumbnailUrl = (url) => {
  if (!url) {
    return '';
  }

  url = url.trim().split(' ').join('%20');
  if (url.startsWith("https://") || url.startsWith('https://xcell-cms-files.s3.amazonaws.com') || url.startsWith("https://xcell-cms-files.s3.ap-south-1.amazonaws.com")) {
    return url;
  } else {
    return 'https://xcell-cms-files.s3.amazonaws.com' + url;
  }
};